import { render, staticRenderFns } from "./GroupAccessEdit.vue?vue&type=template&id=6fadba17&scoped=true&"
import script from "./GroupAccessEdit.vue?vue&type=script&lang=ts&"
export * from "./GroupAccessEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAccessEdit.vue?vue&type=style&index=0&id=6fadba17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadba17",
  null
  
)

export default component.exports